import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Element } from 'react-scroll';
import { propFunc, propOneOf, propArrayShape, } from '../../../../../helpers/custom-prop-types';
import ProfessionalUnitItemsList from '../../Parts/ProfessionalUnitItemsList';
import ProfessionalUnitSectionTitle from '../../Parts/ProfessionalUnitSectionTitle';
import ProfessionalUnitSolutionWrapper from './ProfessionalUnitSolutionWrapper';
const ProfessionalUnitSolutions = (props) => {
    const { showAlertModal, solutions, userMode } = props;
    if (!solutions.length) {
        return null;
    }
    return (_jsxs("section", Object.assign({ className: 'unit_solutions' }, { children: [_jsx(Element, { name: 'section_solutions' }), _jsx(ProfessionalUnitSectionTitle, { count: solutions.length, title: '事例', unit: '件' }), _jsx("p", Object.assign({ className: 'section_text' }, { children: "\u8A73\u7D30\u30DA\u30FC\u30B8\u3067\u306F\u3001\u5177\u4F53\u7684\u306A\u691C\u8A0E\u306E\u9032\u3081\u2F45\u3092\u30B9\u30E9\u30A4\u30C9\u5F62\u5F0F\u3067\u95B2\u89A7\u3067\u304D\u307E\u3059" })), _jsx(ProfessionalUnitItemsList, { className: 'solution_items', guestMoreText: '事例紹介をすべて見る（会員登録）', items: solutions, renderComponent: _jsx(ProfessionalUnitSolutionWrapper, { showAlertModal: showAlertModal, userMode: userMode }), showAlertModal: showAlertModal, userMode: userMode })] })));
};
ProfessionalUnitSolutions.propTypes = {
    showAlertModal: propFunc().isRequired,
    solutions: propArrayShape().isRequired,
    userMode: propOneOf(['view', 'guest', 'other', 'pre']).isRequired,
};
export default ProfessionalUnitSolutions;
